import React, { useCallback, useEffect, useState } from 'react';
import {
  Accordion, AccordionSummary, AccordionDetails,
  Checkbox, FormControlLabel, Slider, Button,
  Typography, Box, FormGroup,
  Chip
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GET_FILTERS, SEARCH_PRODUCTS } from '../../redux/apis';
import { axiosPublicInstance } from '../../redux/axiosInstance';
import CancelIcon from '@mui/icons-material/Cancel';

const FilterSidebar: React.FC<any> = ({ updateData }) => {
  const [priceRange, setPriceRange] = useState<number[]>([0, 1000000]);
  const [data, setData] = useState<any>();
  const [selectedBrands, setSelectedBrands] = useState<any[]>([]);
  const [selectedModels, setSelectedModels] = useState<any[]>([]);

  const handlePriceChange = (event: Event, newValue: number | number[]) => {
    setPriceRange(newValue as number[]);
  };

  useEffect(() => {
    getFilters();
  }, [selectedBrands, selectedModels]);

  const getFilters = async () => {
    try {
      // const response = await axiosPublicInstance.get(GET_FILTERS);
      // if (response) {
      //   setData(response.data);
      // } else {
      //   console.warn("No Response");
      // }
      const datas = {
        "Brand": [
          "Samsung",
          "LG",
          "Sony",
          "Panasonic",
          "Bosch"
        ],
        "Model": [
          "Galaxy S21",
          "QLED 55",
          "Bravia X90",
          "Lumix GH5",
          "SmartHome 2025"
        ]
      }

      setData(datas)
    } catch (error) {
      console.error(error)
    }
  };

  const handleBrandFilter = (e: any, item: any, index: number) => {
    if (e.checked) {
      setSelectedBrands([...selectedBrands, item]);
    } else {
      const updatedList = selectedBrands.filter((b) => b !== item);
      setSelectedBrands(updatedList);
    }
  };

  const handleModelFilter = (e: any, item: any, index: number) => {
    if (e.checked) {
      setSelectedModels([...selectedModels, item]);
    } else {
      const updatedList = selectedModels.filter((b) => b !== item);
      setSelectedModels(updatedList);
    }
  };

  const handleSubmit = async () => {
    let search_url = SEARCH_PRODUCTS + "?page=0&pageSize=12";
    let searchParams = "";
    if (priceRange && priceRange.length > 0) {
      searchParams = searchParams + "&minPrice=" + priceRange[0] + "&maxPrice=" + priceRange[1];
    }
    if (selectedBrands && selectedBrands.length > 0) {
      selectedBrands.forEach(brand => {
        searchParams = searchParams + "&brands=" + brand;
      })
    }
    if (selectedModels && selectedModels.length > 0) {
      selectedModels.forEach(model => {
        searchParams = searchParams + "&models=" + model;
      })
    }
    updateData(searchParams);
  }

  const handleReset = useCallback(() => {
    setSelectedBrands([]);
    setSelectedModels([]);
    setPriceRange([0, 50000]);
    let searchParams = "&minPrice=" + priceRange[0] + "&maxPrice=" + priceRange[1];
    updateData(searchParams);
  }, [setSelectedBrands, setSelectedModels, setPriceRange, handleSubmit]);

  return (

    <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: '2px' }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {selectedBrands.map((brand, index) => (
          <Chip
            key={index}
            label={brand}
            variant="outlined"
            onDelete={() => setSelectedBrands(selectedBrands.filter((b) => b !== brand))}
            deleteIcon={<CancelIcon />}
            sx={{ mr: 1, mb: 1 }}
          />
        ))}
        {selectedModels.map((model, index) => (
          <Chip
            key={index}
            label={model}
            variant="outlined"
            onDelete={() => setSelectedModels(selectedModels.filter((b) => b !== model))}
            deleteIcon={<CancelIcon />}
            sx={{ mr: 1, mb: 1 }}
          />
        ))}
      </Box>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography style={{ fontWeight: 'bold' }}>Brands</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGroup>
            {data && data.Brand && data.Brand.length > 0 &&
              data.Brand.map((brand: any, index: any) => (
                <FormControlLabel
                  key={brand}
                  control={
                    <Checkbox
                      checked={selectedBrands.includes(brand)}
                      onChange={(e) => handleBrandFilter(e.target, brand, index)}
                    />
                  }
                  label={brand}
                />
              ))
            }
          </FormGroup>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography style={{ fontWeight: 'bold' }}>Models</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGroup>
            {data && data.Model && data.Model.length > 0 &&
              data.Model.map((model: any, index: any) => (
                <FormControlLabel
                  key={model}
                  control={
                    <Checkbox
                      checked={selectedModels.includes(model)}
                      onChange={(e) => handleModelFilter(e.target, model, index)}
                    />
                  }
                  label={model}
                />
              ))
            }
          </FormGroup>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography style={{ fontWeight: 'bold' }}>Filter By Price</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography gutterBottom>Price: </Typography>
          <Slider
            value={priceRange}
            onChange={handlePriceChange}
            valueLabelDisplay="auto"
            min={0}
            max={50000}
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography>${priceRange[0]}</Typography>
            <Typography>${priceRange[1]}</Typography>
          </Box>

        </AccordionDetails>

      </Accordion>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', padding: '5px' }}>
        <Button variant="contained" sx={{ backgroundColor: "#0f456c" }} fullWidth onClick={handleSubmit}>
          Filter
        </Button>
        <Button variant="contained" sx={{ backgroundColor: "#c72a22" }} fullWidth onClick={handleReset}>
          Clear
        </Button>
      </Box>
    </Box>
  );
};

export default FilterSidebar;